import Forum from './Forum';
export default Forum;